import { useMemo } from 'react';
import { ConnectedApps } from '../../components/jit-qa/QATextInputView';
import { AppState } from '../../constants';
import { useAppConnectionStatus } from '../../pages/onboarding/WorkspaceSetupPage/hooks/app-connection-summary';

interface SortedInstantApps {
  sortedInstantConnectedApps: ConnectedApps[];
}

export const useSortedInstantApps = (): SortedInstantApps => {
  const connectedApps = useAppConnectionStatus();
  const sortedInstantConnectedApps = useMemo(() => {
    const instantConnectedApps = connectedApps.reduce(
      (acc: ConnectedApps[], curr) => {
        if (curr.isInstant && curr.statusCode !== AppState.ErrorReconnect) {
          acc.push({
            id: curr.id,
            appName: curr.appName,
            displayName: curr.displayName,
          });
        }

        return acc;
      },
      []
    );

    const uniqueConnectedApps = instantConnectedApps.filter(
      (app, index, self) =>
        index === self.findIndex((t) => t.appName === app.appName)
    );

    uniqueConnectedApps.sort((appA, appB) => {
      return appA.appName.localeCompare(appB.appName);
    });

    return uniqueConnectedApps;
  }, [connectedApps]);

  return {
    sortedInstantConnectedApps,
  };
};
